
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopanvelcabs() {



  const cardData =
  {
    keyword: 'Pune to Panvel Cabs',
    heading: 'AB Ghule Cabs: Pune to Panvel Cabs',
    headingDescription: 'Traveling from Pune to Panvel? Look no further than AB Ghule Cabs for a reliable, comfortable, and affordable cab service. Our experienced drivers and well-maintained vehicles ensure that you have a smooth and hassle-free journey from Pune to Panvel, whether for business, leisure, or a weekend getaway. The approximate distance from Pune to Panvel is around 150 km.',

    top: 'Top Places to Visit in Panvel with AB Ghule Cabs',

    "topPlaces": [
  {
    title: "Karnala Fort",
    description: "Located about 12 km from Panvel, Karnala Fort is a historic hill fort that offers scenic views and a trekking experience. It’s a great spot for history buffs and nature lovers alike."
  },
  {
    title: "Karnala Bird Sanctuary",
    description: "Adjacent to the Karnala Fort, this sanctuary is home to hundreds of bird species. A paradise for birdwatchers, it provides a tranquil environment for nature walks and picnics."
  },
  {
    title: "Matheran",
    description: "A short drive from Panvel, Matheran is a charming hill station known for its lush landscapes, viewpoints, and walking trails. It’s an ideal destination for a peaceful retreat away from the city hustle."
  },
  {
    title: "Pandavkada Falls",
    description: "Located near Panvel, Pandavkada Falls is a popular tourist spot, especially during the monsoon season. The waterfall and its surrounding lush greenery offer a picturesque environment."
  },
  {
    title: "Baba’s Garden",
    description: "A serene spot for relaxation, Baba’s Garden in Panvel offers a peaceful environment with greenery, perfect for a quiet afternoon."
  },
  {
    title: "Murud-Janjira Fort",
    description: "A historic sea fort located about 60 km from Panvel, Murud-Janjira Fort is one of the most well-preserved sea forts in India. A boat ride takes you to this remarkable fort."
  },
  {
    title: "Nerul Balaji Temple",
    description: "Dedicated to Lord Venkateshwara, this temple is a replica of the Tirupati Temple in Andhra Pradesh. It’s a popular pilgrimage destination for devotees."
  },
  {
    title: "Belapur Fort",
    description: "Located in the Navi Mumbai region, Belapur Fort offers a glimpse into the area’s historical significance. The fort and its surroundings provide a peaceful environment to explore and enjoy nature."
  },
  {
    title: "Elephanta Caves",
    description: "Although a bit further away, Elephanta Caves near Mumbai are accessible from Panvel. These ancient rock-cut temples and caves are an important archaeological site and UNESCO World Heritage Site."
  },
  {
    title: "City of Navi Mumbai",
    description: "A well-planned city with modern infrastructure, Navi Mumbai offers a variety of shopping, dining, and entertainment options, making it a good stop for leisure or business travelers heading to Panvel."
  }
],


services: [
    {
      "name": "Pune to Panvel Cabs",
      description: "Travel with ease from Pune to Panvel with AB Ghule Cabs. We provide a variety of vehicle options, ensuring a comfortable and safe journey for all kinds of travelers."
    },
    {
      "name": "Pune to Panvel Taxi Booking",
      description: "Booking a taxi from Pune to Panvel is simple and convenient with AB Ghule Cabs. Whether you're looking for a one-way or round-trip ride, we offer hassle-free online booking options."
    },
    {
      "name": "Pune to Panvel Car Rental",
      description: "Need a car rental for your trip from Pune to Panvel? Choose from our fleet of well-maintained vehicles, perfect for your comfort and convenience."
    },
    {
      "name": "Pune to Panvel Taxi Rates",
      description: "Our competitive Pune to Panvel taxi rates make sure you get the best deal without compromising on comfort or quality."
    },
    {
      "name": "Pune to Panvel Cab Charges",
      description: "At AB Ghule Cabs, we offer affordable cab charges from Pune to Panvel, with no hidden fees or surprises. Check our prices and plan your journey without worries."
    },
    {
      "name": "Pune to Panvel Cab Pricing",
      description: "We offer transparent pricing for your trip from Pune to Panvel. Our cab pricing is clear and competitive, ensuring you get great value for your money."
    },
    {
      "name": "Pune to Panvel Private Car Hire",
      description: "For a more private and comfortable journey, book a private car hire for your trip from Pune to Panvel. AB Ghule Cabs provides a range of vehicles to suit your preferences."
    },
    {
      "name": "Pune to Panvel Cab Cost",
      description: "Get an estimate of the Pune to Panvel cab cost before you book. Our pricing system ensures that your travel budget stays intact, while offering a seamless travel experience."
    },
    {
      "name": "Pune to Panvel Taxi Service",
      description: "Experience reliable and comfortable taxi service from Pune to Panvel with AB Ghule Cabs. We offer a range of vehicles to ensure your journey is smooth and punctual."
    },
    {
      "name": "Pune to Panvel Travel Cabs",
      description: "Our Pune to Panvel travel cabs are designed to make your trip comfortable and enjoyable. Choose from a variety of vehicle options that fit your travel needs."
    },
    {
      "name": "Pune to Panvel Cabs",
      description: "AB Ghule Cabs offers several options for Pune to Panvel cabs, whether you're traveling solo, with family, or in a group. Book a cab that suits your needs and enjoy a comfortable ride."
    },
    {
      "name": "Pune to Panvel Cab Booking",
      description: "Booking your Pune to Panvel cab is easy with AB Ghule Cabs. Choose the vehicle that suits your needs and enjoy a comfortable journey to your destination."
    },
    {
      "name": "Pune to Panvel Cab Fare",
      description: "The Pune to Panvel cab fare is competitive and affordable. Check the fare before booking and enjoy a cost-effective ride."
    },
    {
      "name": "Pune to Panvel Cab One-Way",
      description: "If you're looking for a one-way cab from Pune to Panvel, AB Ghule Cabs offers convenient options with a fixed price for your journey."
    },
    {
      "name": "Pune to Panvel Cab Price",
      description: "Our Pune to Panvel cab price is transparent and affordable. No hidden charges, just straightforward pricing for a hassle-free experience."
    },
    {
      "name": "Pune to Panvel Distance Taxi",
      description: "Planning your trip based on the Pune to Panvel distance? Our cabs are ready to cover the distance with comfort and efficiency, ensuring a smooth ride."
    },
    {
      "name": "Pune to Panvel Taxi",
      description: "Book a taxi from Pune to Panvel with AB Ghule Cabs and enjoy a comfortable, hassle-free journey. We offer multiple vehicle options for your convenience."
    },
    {
      "name": "Pune to Panvel Taxi Fare",
      description: "Our Pune to Panvel taxi fare is designed to be affordable and transparent. Enjoy a smooth ride with no surprises."
    },
    {
      "name": "Pune to Panvel Tempo Traveller on Rent",
      description: "For group travel, rent a Tempo Traveller from Pune to Panvel. Spacious and comfortable, it's perfect for larger groups or corporate outings."
    },
    {
      "name": "Pune to Navi Mumbai Cab",
      description: "Travel comfortably from Pune to Navi Mumbai with AB Ghule Cabs. Book your cab today and enjoy a convenient journey."
    },
    {
      "name": "Pune to Navi Mumbai Airport Cab",
      description: "Book a taxi for your Pune to Navi Mumbai airport journey with AB Ghule Cabs. We ensure timely arrivals and departures to and from the airport."
    },
    {
      "name": "Pune to Navi Mumbai Airport Taxi Service",
      description: "Choose AB Ghule Cabs for your Pune to Navi Mumbai airport taxi service. We offer timely, reliable, and comfortable rides to the airport."
    },
    {
      "name": "Pune to Panvel Cabs Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Panvel Cabs. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Pune to Panvel Cabs", "-Pune to Panvel Taxi Booking"],
    ["Pune to Panvel Car Rental", "-Pune to Panvel Taxi Rates"],
    ["Pune to Panvel Cab Charges", "-Pune to Panvel Cab Pricing"],
    ["Pune to Panvel Private Car Hire", "-Pune to Panvel Cab Cost"],
    ["Pune to Panvel Taxi Service", "-Pune to Panvel Travel Cabs"],
    ["Pune to Panvel Cabs", "-Pune to panvel cab booking"],
    ["Pune to panvel cab fare", "-Pune to panvel cab one way"],
    ["Pune to panvel cab price", "-Pune to panvel distance taxi"],
    ["Pune to panvel taxi", "-pune to panvel taxi fare"],
    ["Pune to panvel tempo traveller on rent", "-pune to navi mumbai cab"],
    ["Pune to navi mumbai airport cab", "-pune to navi mumbai airport taxi service"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Professional Service",
      WhyChoosedescription: "At AB Ghule Cabs, we provide reliable, timely, and professional taxi services from Pune to Panvel. Our goal is to make your journey safe, comfortable, and enjoyable."
    },
    {
      WhyChooseheading: "Affordable Pricing",
      WhyChoosedescription: "We offer competitive and transparent pricing with no hidden charges. You’ll find our rates budget-friendly, ensuring you get the best value for your money on your trip from Pune to Panvel."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription: "Our fleet of cars is regularly cleaned, maintained, and inspected. We provide a variety of vehicles, including sedans, SUVs, and luxury cars, to match your comfort and travel needs."
    },
    {
      WhyChooseheading: "Experienced and Courteous Drivers",
      WhyChoosedescription: "Our drivers are experienced, friendly, and committed to providing excellent service. They are familiar with the best routes and ensure your safe and smooth journey from Pune to Panvel."
    },
    {
      WhyChooseheading: "On-Time Pick-Up and Drop-Off",
      WhyChoosedescription: "Time is important, and we respect that. Our drivers always ensure on-time pick-up and drop-off, allowing you to reach Panvel without delays, whether it's for business or leisure."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "Whether you need a taxi early in the morning or late at night, AB Ghule Cabs is available round the clock to serve you. Our customer service is always ready to assist you with your booking."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "Booking your cab from Pune to Panvel is simple and convenient. You can book online through our website or app, or by calling our customer service for assistance."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a taxi from Pune to Panvel?',
      answer: 'You can easily book a taxi through our website, mobile app, or by calling our customer service team.',
    },
    {
      id: 'FAQ2',
      question: 'What is the fare for a one-way trip from Pune to Panvel?',
      answer: 'The one-way fare for a sedan typically ranges from ₹2,500 to ₹3,200. The fare will depend on the vehicle type and any additional factors like waiting time or detours.',
    },
    {
      id: 'FAQ3',
      question: 'Are the fares inclusive of taxes and tolls?',
      answer: 'Yes, the fares are inclusive of all taxes, tolls, and other charges.',
    },
    {
      id: 'FAQ4',
      question: 'How long will the journey from Pune to Panvel take?',
      answer: 'The journey usually takes around 2.5 to 3.5 hours, depending on traffic conditions.',
    },
    {
      id: 'FAQ5',
      question: 'Do you offer round-trip services for Pune to Panvel?',
      answer: 'Yes, we offer round-trip bookings for your convenience. Feel free to ask about the best rates for your return trip.',
    },
    {
      id: 'FAQ6',
      question: 'Can I book a pick-up from any location in Pune?',
      answer: 'Yes, we offer pick-up from any location in Pune, including hotels, residences, and offices.',
    },
    {
      id: 'FAQ7',
      question: 'Are the vehicles air-conditioned?',
      answer: 'Yes, all our vehicles are air-conditioned, ensuring a comfortable ride.',
    },
    {
      id: 'FAQ8',
      question: 'How do I pay for the ride?',
      answer: 'You can pay through cash, credit/debit card, or via our mobile app, whichever is most convenient for you.',
    },
    {
      id: 'FAQ9',
      question: 'Are there any extra charges for waiting or detours?',
      answer: 'Extra charges may apply for waiting time or detours, but we always inform you of these charges in advance.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Rajesh Joshi',
      feedback: 'I had a smooth ride from Pune to Panvel with AB Ghule Cabs. The driver was punctual and professional, and the car was in great condition. I would definitely recommend their services.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Meera Kapoor',
      feedback: 'AB Ghule Cabs made my trip to Panvel hassle-free. The booking process was simple, and the driver knew the best routes to avoid traffic. I had a comfortable and relaxing ride. Great service!',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Panvel Cabs | Affordable Taxi & Car Rental Services</title>
  <meta name="description" content="Book a taxi from Pune to Panvel with AB Ghule Cabs. Get the best fares for one-way and round trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Pune to Panvel Cabs, Pune to Panvel Taxi Booking, Pune to Panvel Car Rental, Pune to Panvel Taxi Rates, Pune to Panvel Cab Charges, Pune to Panvel Cab Pricing, Pune to Panvel Private Car Hire, Pune to Panvel Cab Cost, Pune to Panvel Taxi Service, Pune to Panvel Travel Cabs, Pune to Panvel Cabs, Pune to Panvel Cab Booking, Pune to Panvel Cab Fare, Pune to Panvel Cab One Way, Pune to Panvel Cab Price, Pune to Panvel Distance Taxi, Pune to Panvel Taxi, Pune to Panvel Taxi Fare, Pune to Panvel Tempo Traveller on Rent, Pune to Navi Mumbai Cab, Pune to Navi Mumbai Airport Cab, Pune to Navi Mumbai Airport Taxi Service" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Panvel Cabs | Affordable Taxi & Car Rental Services" />
  <meta property="og:description" content="Book a taxi from Pune to Panvel with AB Ghule Cabs. Get the best fares for one-way and round trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-panvel-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-panvel-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Panvel Cabs",
        description: "Book a taxi from Pune to Panvel with AB Ghule Cabs. Get the best fares for one-way and round trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-panvel-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-panvel-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-panvel-cabs.jpg",
        "priceRange": "₹2000 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-panvel-cabs",
          "priceCurrency": "INR",
          "price": "2000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "80"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh S"
            },
            "datePublished": "2024-11-15",
            "reviewBody": "Booked a cab for a trip to Panvel. The driver was excellent and the ride was very comfortable. Highly recommend AB Ghule Cabs!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Suman P"
            },
            "datePublished": "2024-09-30",
            "reviewBody": "We had a great experience with AB Ghule Cabs on our trip to Panvel. The vehicle was well-maintained, and the driver was very professional."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Panvel Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.9798",
            "longitude": "73.1207"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-panvel-cabs"
        },
        "keywords": "Pune to Panvel Cabs, Pune to Panvel Taxi Booking, Pune to Panvel Car Rental, Pune to Panvel Taxi Rates, Pune to Panvel Cab Charges, Pune to Panvel Cab Pricing, Pune to Panvel Private Car Hire, Pune to Panvel Cab Cost, Pune to Panvel Taxi Service, Pune to Panvel Travel Cabs, Pune to Panvel Cabs, Pune to Panvel Cab Booking, Pune to Panvel Cab Fare, Pune to Panvel Cab One Way, Pune to Panvel Cab Price, Pune to Panvel Distance Taxi, Pune to Panvel Taxi, Pune to Panvel Taxi Fare, Pune to Panvel Tempo Traveller on Rent, Pune to Navi Mumbai Cab, Pune to Navi Mumbai Airport Cab, Pune to Navi Mumbai Airport Taxi Service"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/53.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetopanvelcabs;